export enum GalleryTypeEnum {
  Attendees = 'ATTENDEES',
  VIP = 'VIP',
  Staff = 'STAFF',
  Performers = 'PERFORMERS',
  General = 'GENERAL',
  Event = 'EVENT',
  Reference = 'REFERENCE',
}